import type { AxiosInstance } from "axios";
import { errorLogger, requestLogger, responseLogger } from "./logger";

export function applyNetworkInterceptors(client: AxiosInstance): AxiosInstance {
  client.interceptors.request.use(requestLogger, errorLogger);
  client.interceptors.response.use(responseLogger, errorLogger);

  return client;
}
